import { Configuration, DefaultApi } from '@rtkwlf/rendall';

import { fetchWithToken } from '@platform/core/auth';

import { env } from '@packages/utils/env';

let client: DefaultApi;
let clientPod: string;

export const initializeRendallApiClient = (pod: string) => {
  if (!client || clientPod !== pod) {
    clientPod = pod;
    client = new DefaultApi(
      new Configuration({
        basePath: env.VITE_RENDALL_BASE_PATH.replace('{{pod}}', pod),
        fetchApi: fetchWithToken,
      }),
    );
  }
};

export const getRendallApiClient = () => {
  if (!client) {
    throw new Error('Rendall client not initialized');
  }

  return client;
};
